/**
 * Created by shunge on 2018/11/01.
 */
var config = {
  //开发环境
  // baseUrl: 'http://192.168.0.30:8080/api',
  baseUrl: "http://localhost:8088/api",
  filebBaseUrl: "http://www.ilinklink.com:81",
  // proxyUrl: 'http://www.ilinklink.com:8086',
  proxyUrl: "http://localhost:8786", // v1.0.2
  //测试环境192.168.0.32
  //baseUrl: 'http://localhost:8086',
  // proxyUrl: 'http://www.ilinklink.com:8085',
  //filebBaseUrl: 'http://www.ilinklink.com:81',
  //正式环境
  //baseUrl: 'www.ilinklink.com:81'

  //文件上传最大限制 单位：M
  fileSize: 50
};

try {
  if (module) {
    module.exports = config;
  }
} catch (ex) {}



//////////////////
// WEBPACK FOOTER
// ./static/lib/config.js
// module id = fusJ
// module chunks = 13